import { postRequest, ApiResponse } from "@/data/apiClient";

export async function userPasswordUpdate(password: {
  userId: number;
  currentPassword: string;
  newPassword: string;
}): Promise<ApiResponse<unknown>> {
  return postRequest("user/updatePassword", password);
}
